/* eslint-disable jsx-a11y/anchor-is-valid */
import {RealDeviceForm} from "pages/admin/devices/form/RealDeviceForm"
import {DialogBoxProps} from "common/DialogBox"
import {DeviceInput} from "./DeviceInput";
import {RealDevice} from "dto/realdevice/devices"
import {AxiosError} from "axios";
import {useRegisterRealDeviceMutation} from "hooks/queries/real-device.query"
import {useQueryClient} from "react-query"

interface RegisterDeviceProps extends DialogBoxProps {
}

export const RegisterDevice = ({show, close,}: RegisterDeviceProps) => {
    const queryClient = useQueryClient()
    const registerRealDevice = useRegisterRealDeviceMutation()
    const onSubmit = async (value: DeviceInput) => {
        const device: RealDevice = {
            name: value.name,
            serialNumber: value.serialNumber,
            ignoreExternalEmission: value.ignoreExternalEmission,
            mobile: {phoneNumber: value.mobile},
            address: {
                address: value.address,
                subAddress: value.subAddress
            },
            etc: value.etc,
            communicationDevice: {
                eui: value.deviceEui.toLowerCase(),
            },
            protector: {
                name: value.protectorName || '',
                mobile: value.protectorMobile || ''
            },
            secondaryProtector: {
                name: value.secondaryProtectorName || '',
                mobile: value.secondaryProtectorMobile|| ''
            }
        }

        const param = {
            device,
            file: value.imgFile,
            imgFiles: value.localImgFiles
        }
        registerRealDevice.mutate(param, {
            onSuccess: (data, variables, context) => {
                console.log("success value : ", data, variables, context)
                queryClient.invalidateQueries(["real-device/list"])
                close()
            },
            onError: (err, variables, context) => {
                const error = (err as AxiosError)
                console.log("error value : ", error, variables, context)
            },
        })
    }
    return (
        <RealDeviceForm show={!!show} close={close} onSubmit={onSubmit}/>
    )
}

